module.exports = django;


//////////////////
// WEBPACK FOOTER
// external "django"
// module id = 63
// module chunks = 0